module.exports = __webpack_public_path__ + "static/OP1-9e7eed3e0907ba092baad47e0b55442c.png";